import Devise from "@kaspernj/api-maker/build/devise"
import env from "shared/env"

const peakflowJsAuthToken = globalThis.PEAKFLOW_JS_AUTH_TOKEN || env["PEAKFLOW_JS_AUTH_TOKEN"]

if (peakflowJsAuthToken) {
  globalThis.peakFlowErrors = new Peakflow.BugReporting({authToken: peakflowJsAuthToken}) // eslint-disable-line no-undef
  globalThis.peakflowErrors = globalThis.peakFlowErrors
  globalThis.peakFlowErrors.collectEnvironment(() => {
    return {
      currentUserId: Devise.currentUser()?.id(),
      currentUserEmail: Devise.currentUser()?.email()
    }
  })
}
